/* eslint-disable no-undef */
import './assets/styles/main.scss';
import './App.css';
import './sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
import { i18next } from 'store/modules/base/i18n';
import { toggleBlurEffect } from 'store/modules/virtual-background/actions';
import App from './App';
import reportWebVitals from './reportWebVitals';
import BaseTheme from 'store/modules/base/ui/BaseTheme';
import conference from 'conference';
import API from 'util/API/API';
import UI from 'util/UI/UI';
import translation from 'util/translation/translation';
import store from './store';
import utils from 'util/utils';
import { showWarningNotification } from 'store/modules/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from 'store/modules/notifications/constants';
import { SET_LOADING } from 'store/modules/login/actions';
window.Buffer = window.Buffer || require('buffer').Buffer;
utils.fetchLocalUUID();
window.APP = {
  API,
  conference,
  store: store,
  // Used by do_external_connect.js if we receive the attach data after
  // connect was already executed. status property can be 'initialized',
  // 'ready', or 'connecting'. We are interested in 'ready' status only which
  // means that connect was executed but we have to wait for the attach data.
  // In status 'ready' handler property will be set to a function that will
  // finish the connect process when the attach data or error is received.
  connect: {
    handler: null,
    status: 'initialized'
  },

  // Used for automated performance tests.
  connectionTimes: {
    'index.loaded': window.indexLoadedTime
  },
  translation,
  UI
};
window.EXCALIDRAW_ASSET_PATH = 'libs/';
try {
  const accessToken = window.localStorage.getItem(
    // eslint-disable-next-line no-undef
    process.env.REACT_APP_AUTH_STORAGE_KEY
  );
  if (accessToken) {
    store.dispatch({ type: SET_LOADING, payload: true });
  }
  if (window.isDesktop) {
    window.censorshipActivated = false;
    window.COM.on('censorship:activate', function () {
      store.dispatch(toggleBlurEffect(true));
    });
    window.COM.on('censorship:deactivate', function () {
      store.dispatch(toggleBlurEffect(false));
    });
    window.COM.on('api:started', function (event, data) {
      window.remoteAPIControlEnabled = data.active;
    });
    window.COM.on('api:disabled', function (event, data) {
      window.remoteAPIControlEnabled = data.active;
    });
    window.COM.on('api:error', function (event, data) {
      store.dispatch(
        showWarningNotification(
          {
            descriptionKey: data.error,
            titleKey: 'notify.remoteAPIControlError'
          },
          NOTIFICATION_TIMEOUT_TYPE.MEDIUM
        )
      );
    });
  }
} catch (e) {
  console.log(e);
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={BaseTheme}>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <App />
      </Provider>
    </I18nextProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
